import { render, staticRenderFns } from "./SamplePlanReview.vue?vue&type=template&id=a57b0db4&"
import script from "./SamplePlanReview.vue?vue&type=script&lang=js&"
export * from "./SamplePlanReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports